import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CacheService, ParameterHandlerService } from 'projects/common/src/app/services';
import { IShift } from 'src/app/modules/core/interfaces';
import { ITableConfig } from '../../../../../../../projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-data-params';
import { ITableExtraParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-extra-params';
import { ITableHeaderParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-header-params';
import { ITableLargeColumnConfig } from '../../../../../../../projects/common/src/app/interfaces/table/table-large-column-config';
import { TableConfigService } from '../../../../../../../projects/common/src/app/services/table/table-config.service';
import { ITotalLoopFilterResult } from '../../../interfaces/report-loop-by-operator';
import { ReportLoopEmbeddedByMachineTruckService } from '../../../services/report-loop-embedded-by-machine-truck.service';
import { ModalReportComponent } from '../modal-report/modal-report.component';

@Component({
  selector: 'app-loop-by-operator-filter-result',
  templateUrl: './loop-by-operator-filter-result.component.html',
  styleUrls: ['./loop-by-operator-filter-result.component.scss'],
})
export class LoopByOperatorFilterResultComponent implements OnChanges {
  @Input() public filteredResult: ITotalLoopFilterResult[];
  public tableConfig: ITableConfig;

  constructor(
    private tableConfigService: TableConfigService,
    private cacheService: CacheService,
    private modalService: NgbModal,
    private _embeddedTruckService: ReportLoopEmbeddedByMachineTruckService,
    private parameterService: ParameterHandlerService,
  ) {}

  /**
   * On component change
   */
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.filteredResult && this.filteredResult) {
      this.setTableConfig(this.filteredResult);
    }
  }

  /**
   * Function to set table config
   */
  private setTableConfig(tableData: any[]): void {
    const data = [];
    tableData.forEach((td) => {
      data.push({
        machineName: td.machineName,
        operator: td.operator,
        streetZoneStart: td.streetZoneStart,
        startZone: td.startZone,
        startedAt: td.startedAt,
        streetZoneEnd: td.streetZoneEnd,
        endZone: td.endZone,
        finishedAt: td.finishedAt,
        difference: td.difference,
        shiftName: td.shiftName,
      });
    });
    tableData.sort((a, b) => {
      if (a.finishedAt > b.finishedAt) return -1;
      if (a.finishedAt < b.finishedAt) return 1;
      return 0;
    });
    const companyId = this.cacheService.local('session').user.company.id;
    const exclude =
      companyId === 4
        ? ['loopOperationTypeId', 'loopOperationTypeDescription']
        : ['loopOperationTypeId', 'loopOperationTypeDescription', 'tonsQty', 'shiftId', 'tagId', 'tons', 'operatorId'];

    const customLargeColumns: ITableLargeColumnConfig[] = [
      { field: 'machineName', isLargeColumn: true, flexGrow: 0.6 },
      { field: 'operator', isLargeColumn: true, flexGrow: 2 },
      { field: 'streetZoneStart', isLargeColumn: true, flexGrow: 0.6 },
      { field: 'startZone', isLargeColumn: true, flexGrow: 0.6 },
      { field: 'startedAt', isLargeColumn: true, flexGrow: 1.2 },
      { field: 'streetZoneEnd', isLargeColumn: true, flexGrow: 0.6 },
      { field: 'endZone', isLargeColumn: true, flexGrow: 0.7 },
      { field: 'finishedAt', isLargeColumn: true, flexGrow: 1.2 },
      { field: 'tonsQty', isLargeColumn: true, flexGrow: 1 },
      { field: 'shiftName', isLargeColumn: true, flexGrow: 0.6 },
    ];

    const headerParams: ITableHeaderParams = {
      data,
      sortables: [
        'machineName',
        'operator',
        'streetZoneStart',
        'startZone',
        'startedAt',
        'streetZoneEnd',
        'endZone',
        'finishedAt',
        'tonsQty',
        'difference',
        'shiftName',
      ],
      replaceColumnName: [
        { prevName: 'machineName', newName: 'machineType' },
        { prevName: 'finishedAt', newName: 'finishedat' },
        { prevName: 'durationAtSeconds', newName: 'Duración' },
        { prevName: 'shiftName', newName: 'shiftname' },
        { prevName: 'startdateAt', newName: 'Fecha Inicio de vuelta' },
        { prevName: 'finalDateAt', newName: 'Fecha Final de vuelta' },
        { prevName: 'duration', newName: 'Tiempo total vuelta' },
      ],
      customLargeColumns,
      excludeColumns: exclude,
    };
    const datasetParams: ITableDataParams = {
      tableData: data,
      dateConfig: [
        { field: 'startedAt', format: 'date-time' },
        { field: 'startdateAt', format: 'date-time' },
        { field: 'finishedAt', format: 'date-time' },
        { field: 'finalDateAt', format: 'date-time' },
      ],
      colorConfig: [{ field: 'machineName', isBold: true }],
      customLargeColumns,
      excludeColumns: exclude,
      clickConfig: [
        {
          field: 'detail',
          hasBoldHover: true,
          hasCursorPointer: true,
        },
      ],
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);
    const extraParams: ITableExtraParams = {
      noDataMsg: 'm034',
      disableFooter: false,
      minimalRows: 10,
      quantityPerPage: 10,
    };

    this.tableConfig = null;
    setTimeout(() => (this.tableConfig = { header, dataset, extraParams }), 0);
  }

  /**
   * Open modal Detail
   */
  public clickColumn(event): void {
    const params = {
      startDate: event.row[4].value,
      endDate: event.row[5].value,
      machineId: event.row[1].value,
      shiftId: +(this.parameterService.parameters.item('shift').value as IShift).shiftId,
      companyId: this.cacheService.local('session').user.company.id,
    };

    this._embeddedTruckService.getLoopDetailByEmbedded(params).subscribe({
      next: (result) => {
        const openModal = this.modalService.open(ModalReportComponent, { centered: true, windowClass: 'modal-report-loop' });
        openModal.componentInstance.tableData = result;
      },
    });
  }
}
